import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { pauseFuelingService } from '../../api/fueling-service.ts';

export default function usePauseFuelingService(): UseMutationResult<
  Awaited<ReturnType<typeof pauseFuelingService>>,
  Error,
  string
> {
  return useMutation({
    mutationFn: (serviceId: string) => pauseFuelingService(serviceId),
  });
}
